const Upload = (($) => {

    const NAME = 'upload';
    const DATA_KEY = `bs.${NAME}`;
    const JQUERY_NO_CONFLICT = $.fn[NAME];

    const Default = {
        fileButtonClass: 'action btn btn-default',
        fileButtonHtml: 'Browse...',
        fileDefaultHtml: 'No file selected'
    };
    const Selector = {
        CLASS_NAME: `.js-${NAME}`
    }

    class Upload {
        constructor(element, config) {
            this._config = config;
            this._element = element;
            this._$element = $(element);

            // temp fix to show all selected file ... need timeout since uniform beat us to it
            if (this._$element.prop('multiple')) {
                this._$element.on('change', () => {
                    setTimeout(() => this._$element.siblings('.filename').text($.map(this._element.files, file => file.name).join(', ')), 500);
                });
            }
        }

        dispose() {
            $.removeData(this._element, DATA_KEY);
            this._config = null;
            this._element = null;
            this._$element = null;
        }

        static _jQueryInterface() {
            return this.each(function () {
                const $this = $(this);
                let data = $this.data(DATA_KEY);
                const config = $.extend({}, Default, $this.data());
                if (!data) {
                    data = new Upload(this, config);
                    $this.data(DATA_KEY, data).uniform(config);
                }
            });
        }
    }

    $(() => Upload._jQueryInterface.call($(Selector.CLASS_NAME)));
    $(document).ajaxStop(() => Upload._jQueryInterface.call($(Selector.CLASS_NAME)));

    $.fn[NAME] = Upload._jQueryInterface;
    $.fn[NAME].Constructor = Upload;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Upload._jQueryInterface;
    }

    return Upload;
})(jQuery);